import React from "react";
import { getClipSnapSiteOrigin, getClipSnapToolLink } from "client/config/externalEditors";
import { getRouteFormLink } from "components/common/LinkRenderer/LinkRendererLinks";
import Link from "next/link";
import { cn } from "lib/utils";

export interface LinkRendererProps {
    label: string;
    linkKey: string;
    className?: string;
}

const LinkRenderer = ({ label, linkKey, className }: LinkRendererProps) => {
    let route = getRouteFormLink(linkKey);
    let externalRoute = false;

    if (!route && linkKey.startsWith("link:clipsnap")) {
        externalRoute = true;
        const clipsnapDomain = getClipSnapSiteOrigin();
        switch (linkKey) {
            case "link:clipsnap_ai_bg_remover_link":
                route = getClipSnapToolLink("background-remover");
                break;
            case "link:clipsnap_ai_image_enhancer_link":
                route = getClipSnapToolLink("image-enhancer");
                break;
            case "link:clipsnap_generative_fill_link":
                route = getClipSnapToolLink("generative-fill");
                break;
            case "link:clipsnap_ai_bg_generator_link":
                route = getClipSnapToolLink("ai-background-generator");
                break;
            case "link:clipsnap_image_enhancer_link":
                route = getClipSnapToolLink("image-enhancer");
                break;
            case "link:clipsnap_image_upscaler_link":
                route = getClipSnapToolLink("image-upscaler");
                break;
            case "link:clipsnap_ai_image_generator_link":
                route = getClipSnapToolLink("ai-image-generator");
                break;
            case "link:clipsnap_ai_art_generator_link":
                route = getClipSnapToolLink("ai-art-generator");
                break;
            case "link:clipsnap_blur_background_link":
                route = getClipSnapToolLink("blur-background");
                break;
            case "link:clipsnap_home_page_link":
                route = `${clipsnapDomain}`;
                break;
        }
    }
    if (route) {
        return (
            <Link
                className={cn("cursor-pointer text-irBlue-600 dark:text-darkPrimary-100 font-semibold", className)}
                href={route}
                key={linkKey}
                target={externalRoute ? "_blank" : "_self"}
                referrerPolicy="no-referrer"
            >
                {label}
            </Link>
        );
    }

    return <span>{label}</span>;
};

export default LinkRenderer;
